import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const inputCls =
  "w-full bg-onyx/60 border border-ice/10 rounded-lg px-4 py-3 text-sm text-ice placeholder:text-muted-foreground/50 outline-none focus:border-royal transition-colors";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-onyx hero-grid-bg px-6">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8">
          <img src="/ethic-logo.png?v=6" alt="ETHIC ENERGY" className="h-9 w-auto" />
        </div>
        <form onSubmit={submit} className="bg-surface border border-ice/8 rounded-2xl p-8" data-testid="admin-login-form">
          <div className="flex items-center gap-2 mb-6">
            <Lock size={16} className="text-azure" />
            <h1 className="font-display text-lg font-semibold text-ice">Area CMS — Accesso</h1>
          </div>
          <label className="block text-xs font-mono uppercase tracking-[0.15em] text-muted-foreground mb-2">Email</label>
          <input
            data-testid="admin-login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
            placeholder="admin@ethicenergy.it"
          />
          <label className="block text-xs font-mono uppercase tracking-[0.15em] text-muted-foreground mb-2 mt-5">Password</label>
          <input
            data-testid="admin-login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
            placeholder="••••••••"
          />
          {error && (
            <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-royal hover:bg-azure hover:text-[#0B1424] transition-colors text-white font-semibold px-6 py-3 rounded-full disabled:opacity-60"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            Accedi
          </button>
        </form>
        <p className="text-center mt-6">
          <a href="/" className="text-xs text-muted-foreground hover:text-azure transition-colors">
            ← Torna al sito
          </a>
        </p>
      </div>
    </div>
  );
}
